module.exports = __webpack_public_path__ + "img/92.10c2ce3a.jpg";